<template>

  <div class="page-wrapper">
    <stihl-header v-show="isNotInIframe" ref="header"></stihl-header>
    <div id="menu" class="dss-menu-wrapper">
      <div class="container navbar-expand-sm">
        <dss-menu class="navbar-collapse collapse multi-collapse flex-column flex-sm-row dss-menu"/>
      </div>
    </div>

    <slot></slot>
  </div>

  <stihl-footer v-show="isNotInIframe"></stihl-footer>

</template>

<script lang="ts">
import DssMenu from "./DssMenu.vue";
import StihlHeader from "./StihlHeader.vue";
import StihlFooter from "./StihlFooter.vue";

export default {
  name: "DssTemplate",
  components: {DssMenu, StihlHeader, StihlFooter},
  computed: {
    isNotInIframe: function () {
      return window.self === window.top
    },
  },
}
</script>
